import Header from "../components/Header";
import Footer from "../components/Footer";
import styles from "./../styles/DeleteAccount.module.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DeleteAccountApi } from "../services/Api";

const DeleteAccount = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();



  const handleDeleteAccount = async(e)=>{
    e.preventDefault();
    if(phoneNumber === '' || password === ''){
      return;
    }
    const response = await DeleteAccountApi({phoneNumber,password});
    console.log('DeleteAccountApi response',response)
    if (typeof response === "undefined") {
      console.error("Response is undefined");
      return;
    }
    if (response.code == "200") {
      // const data = await response.json();
      console.log("the response",response.data);
      navigate("/decide", {
              state: {
                success: true,
                message: "Account successfully deleted",
                data: response.data, // Pass any data from the response if needed
              },
            });
      
    }
  }
  return (
    <>
      <Header />
      <div className={styles.container}>
        <form className={styles.form} >
          <h1 className={styles.title}>Delete your account</h1>
          <label className={styles.label} htmlFor="phoneNumber">
            Phone Number
          </label>
          <input
            type="text"
            id="phoneNumber"
            className={styles.input}
            placeholder="4862457935"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />

          <label className={styles.label} htmlFor="password">
            Password
          </label>
          <input
            type="password"
            id="password"
            className={styles.input}
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button type="submit" className={styles.button} onClick={handleDeleteAccount}>
            Delete Account
          </button>
        </form>
      </div>
    </>
  );
};

export default DeleteAccount;
